import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const FaqsPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "faqs",
                    partial: {
                        handler: (props)=> {
                            return props.formHandler.buildArrayInputs("contents", "faqs", "سوالات",{
                                question: {
                                    label: "سوال"
                                },
                                answer: {
                                    label: "جواب"
                                },
                            })
                        },
                    }
                }
            ]
        }
    }
};

export default FaqsPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/FaqsPageBuilder.js